define('vspot-angular/services/paypal-service',[], function () {
    'use strict';

    return ['resources.PayPal', function (PayPal) {

        return {
            // save: function(data) {
            //     return WePay.save(data);
            // },
            //
            // get: function (activityId) {
            //     return WePay.get({ selected_activity: activityId });
            // },
            //
            // query: function(data) {
            //     return WePay.query(data);
            // },

            goAccountRegisterURL: function(activityId,user_country) {
                return PayPal.goAccountRegisterURL({
                    activity_id:    activityId,
                    user_country:   user_country
                });
            },
            onboardingComplete: function(data) {
                return PayPal.onboardingComplete(data);
            },
            getReferralInfo: function(activity_id) {
                return PayPal.getReferralInfo({activity_id: activity_id})
            }
        };

    }];
});

